import { PropTypes } from "prop-types"
import classNames from "classnames"
import _ from "lodash"

import Button from "../Button"
import toggleWrap from "../ToggleWrap"

const collapsableTypes = {
  BASIC: "BASIC",
  WITH_HEADER_CONTENT: "WITH_HEADER_CONTENT"
}

export const CollapsableNode = ({
  children,
  headerChildren,
  className,
  description,
  headerContent,
  id,
  onChange,
  regionAriaLabel,
  action,
  disabled = false,
  isPrintable = false,
  show = false,
  showRegionAriaLabel = true,
  type = collapsableTypes.BASIC
}) => {
  const handleChange = () => {
    onChange(!show)

    if (action) {
      action()
    }
  }

  return (
    <>
      <Button
        className={classNames("oj-collapsable-node", className, {
          open: show,
          closed: !show,
          "with-header-content": type === collapsableTypes.WITH_HEADER_CONTENT
        })}
        aria-controls={`elements-${id}`}
        aria-expanded={show}
        ariaLabel={_.isFunction(description) ? description({ show }) : description}
        id={id}
        onClick={handleChange}
        disabled={disabled}
      >
        {headerContent && (
          <div className="header-content">
            {_.isFunction(headerContent) ? headerContent({ show }) : headerContent}
          </div>
        )}
        {headerChildren && (
          <div className="header-children">
            {_.isFunction(headerChildren) ? headerChildren({ show }) : headerChildren}
          </div>
        )}
        {type === collapsableTypes.BASIC && (
          <span role="presentation" className="chevron" aria-hidden />
        )}
      </Button>
      {show && (
        <div
          className="collapsable-content"
          id={`elements-${id}`}
          aria-labelledby={showRegionAriaLabel ? regionAriaLabel || id : null}
          role="region"
        >
          {children}
        </div>
      )}
      {!show && isPrintable && <div className="only-print">{children}</div>}
    </>
  )
}

CollapsableNode.propTypes = {
  children: PropTypes.node,
  headerChildren: PropTypes.oneOfType([PropTypes.func, PropTypes.node]),
  className: PropTypes.string,
  disabled: PropTypes.bool,
  description: PropTypes.oneOfType([PropTypes.func, PropTypes.string]),
  headerContent: PropTypes.oneOfType([PropTypes.func, PropTypes.node]),
  id: PropTypes.string.isRequired,
  isPrintable: PropTypes.bool,
  show: PropTypes.bool,
  showRegionAriaLabel: PropTypes.bool,
  onChange: PropTypes.func.isRequired,
  type: PropTypes.oneOf(_.keys(collapsableTypes)),
  regionAriaLabel: PropTypes.string,
  action: PropTypes.func
}

export const StatefulCollapsableNode = toggleWrap(CollapsableNode)

export default StatefulCollapsableNode
